module.exports = __webpack_public_path__ + "static/decrease-sickdays-84177cf4bfa3f7b97e0aed1b348ac6ca.svg";